import { defineComponent as _defineComponent } from 'vue'
import { ref,computed, onMounted } from 'vue'
  import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration'
  import CoverageTimeLine from '@/components/smart/Coverage/CoverageTimeLine.vue'
  import  CoverageIterationLineDetailGlider  from '@/components/smart/Coverage/CoverageIterationLineDetailGlider.vue'  
  import { CoverageState, getCoverageState } from '@/enum/CoverageState';
  import store from '@/store';

  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'CoverageIterationLineDetail',
  props: {
    coverageIteration: null,
    uiid: null
  },
  setup(__props: any) {

const props = __props as {
      coverageIteration:AloDbCoverageIteration,  
      uiid:string
    };

  
  

  const loaded = ref(false)
  const gliderKeys = computed(()=>Object.keys(props.coverageIteration?.resultMipJson || {}).filter(n => n.startsWith('GLIDER')))
  

  onMounted(()=>{            
    if(getCoverageState(props.coverageIteration?.COV_PROCESSING_STATE) == CoverageState.running) { 
      //console.log('coverage iteration running try to get her updated status')
      store.myActions.COVERAGEITERATION_PROGRESSION_REQUEST({itemId:props.coverageIteration.id!,migTyp:store.myGetters.modifiedAdmMissionGlobal.MIG_TYP} ).then(()=>loaded.value = true)
    }
    else{
      loaded.value = true
    }
  })  


return { __sfc: true,props, loaded, gliderKeys, CoverageTimeLine, CoverageIterationLineDetailGlider }
}

})